import { STATUS } from "@/comiq/tokens";

export const StatusBadge = ({ kind, children, testId }) => {
  const s = STATUS[kind] || STATUS.invited;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold"
      style={{ color: s.fg, background: s.bg }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.fg }} />
      {children || s.label}
    </span>
  );
};
